import * as React from "react";
function SvgEmail(props, svgRef) {
  return <svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" ref={svgRef} {...props}><g style={{
      fill: "none",
      stroke: "var(--svg-color, var(--default-svg-color, #000))"
    }}><path d="M21.6 5V19H2V5M21.6 5H2M21.6 5L11.8 12L2 5" strokeWidth={1.5} strokeLinecap="round" strokeLinejoin="round" /></g></svg>;
}
const ForwardRef = React.forwardRef(SvgEmail);
export default __webpack_public_path__ + "src/assets/icons/email.svg";
export const Scaled = {
  "0.5x": __webpack_public_path__ + "src/assets/icons/email_0.5x.svg",
  "1x": __webpack_public_path__ + "src/assets/icons/email_1x.svg",
  "2x": __webpack_public_path__ + "src/assets/icons/email_2x.svg",
  "3x": __webpack_public_path__ + "src/assets/icons/email_3x.svg",
  "4x": __webpack_public_path__ + "src/assets/icons/email_4x.svg"
};
export { ForwardRef as ReactComponent };